import { render, staticRenderFns } from "./ali_oss.vue?vue&type=template&id=24065742&"
import script from "./ali_oss.vue?vue&type=script&lang=js&"
export * from "./ali_oss.vue?vue&type=script&lang=js&"
import style0 from "./ali_oss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports